import FF from "@/components/forms/FormField.module.css";

import { FormFieldChildren, type FormFieldChildrenProps } from "@/components/forms/FormField.tsx";
import { RadioGroupDiv } from "@/components/forms/RadioGroupDiv.tsx";
import { standardFieldAttributes, type StandardFieldProps } from "@/components/forms/standardFieldAttributes.tsx";
import { cn } from "@/utils/classNames.ts";
import type { ReactNode } from "react";
import { RadioGroup, type RadioGroupProps } from "react-aria-components";

interface WRadioGroupProps<T extends string>
    extends Omit<RadioGroupProps, "children" | "className" | "onChange">, StandardFieldProps, FormFieldChildrenProps {
    // Current value
    // (Improve the typing of react-aria-components RadioGroup, which always assumes string values)
    value?: T | null;
    defaultValue?: T | null;
    onChange?: (value: T) => void;

    // Rendering
    className?: string;
    wide?: boolean;
    children: ReactNode;
    block?: boolean;
    headless?: boolean;
}

export function WRadioGroup<T extends string>({
    children,
    className,
    onChange,
    block,
    headless,
    ...props
}: WRadioGroupProps<T>) {
    return (
        <RadioGroup
            className={cn(FF.FormField, className, block && FF.Block, headless && FF.Headless)}
            {...standardFieldAttributes(props)}
            {...props}
            onChange={onChange as RadioGroupProps["onChange"]}
        >
            <FormFieldChildren {...props}>
                <RadioGroupDiv>{children}</RadioGroupDiv>
            </FormFieldChildren>
        </RadioGroup>
    );
}
